(ns journal-app-client.modals
  (:require [journal-app-client.modals.default :as default]
            [journal-app-client.modals.confirm :as confirm]
            [journal-app-client.modals.id-selection :as id-selection]
            [journal-app-client.modals.time-zone-selection :as time-zone-selection]
            [journal-app-client.modals.tag-search :as tag-search]
            [journal-app-client.modals.filter-state-selection :as filter-state-selection]
            [journal-app-client.modals.feedback :as feedback]
            [journal-app-client.components.modal :as m]))

(defn modals [& [id props]]
  (case id
    :confirm [confirm/main id props]
    :id-selection [id-selection/main id props]
    :time-zone-selection [time-zone-selection/main id props]
    :tag-search [tag-search/main id props]
    :filter-state-selection [:f> filter-state-selection/main-fn id props]
    :feedback [:f> feedback/main-fn id props]
    [default/main id props]))

(defn default-modal [index modal-key modal-props]
  [m/view
   {:key              (str modal-key)
    :modal-props      (merge (:modal-props modal-props)
                             {:style (merge (:style (:modal-props modal-props))
                                            {:z-index (+ 32 index)})})
    :background-props (assoc (:background-props modal-props)
                             :style (merge {"--background-opacity" (if (= modal-key :feedback) "0.8" "0.55")
                                            :backdrop-filter       (when (= modal-key :feedback) "blur(12px)")}
                                           (:style (:background-props modal-props))))
    :modal-card-props (if (= modal-key :feedback)
                        (merge
                          {:style {:margin     "0"
                                   :height     "100%"
                                   :width      "100%"
                                   :max-width  "inherit"
                                   :max-height "inherit"}}
                          (:modal-card-props modal-props))
                        (:modal-card-props modal-props))
    :modal-key        modal-key}
   (modals modal-key modal-props)])

(defn right-modal [index modal-key modal-props]
  [m/view
   {:key              (str modal-key)
    :modal-props      (merge (:modal-props modal-props)
                             {:style (merge (:style (:modal-props modal-props))
                                            {:z-index         (+ 32 index)
                                             :align-items     "flex-end"
                                             :justify-content "flex-start"})})
    :background-props (assoc (:background-props modal-props)
                             :style (merge {"--background-opacity" (if (> index 0) "0" "0.55")}
                                           (:style (:background-props modal-props))))
    :modal-card-props (merge (:modal-card-props modal-props)
                             {:animate-in-class  " slide-in-right "
                              :animate-out-class " slide-out-right "
                              :style             (merge {"--slide-in-right-translateX"    "calc(var(--side-panel-fullwidth) + 3rem)"
                                                         "--slide-in-right-opacity-start" "1"
                                                         "--slide-out-right-translateX"   "calc(var(--side-panel-fullwidth) + 3rem)"
                                                         "--slide-out-right-opacity-end"  "1"
                                                         :max-height                      "inherit"
                                                         :height "100%"
                                                         :width "100%"
                                                         :animation-duration              "250ms"
                                                         :margin                          0
                                                         :max-width                       "var(--side-panel-fullwidth)"}
                                                        (:style (:modal-card-props modal-props)))})
    :modal-key        modal-key}
   (modals modal-key modal-props)])

(defn main []
  (let [active-modals @m/variables
        active? (not (or (nil? active-modals) (empty? active-modals)))]
    (when active?
      (into
        [:div#modals]
        (map-indexed
          (fn [index [modal-key modal-props]]
            (case (:type modal-props)
              :right [right-modal index modal-key modal-props]
              [default-modal index modal-key modal-props]))
          active-modals)))))
